function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "location-pin - simple-line-icons");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  fontFamily: "simple-line-icons",
  fontSize: 16,
  fontWeight: "normal"
}, React.createElement("g", {
  id: "Profile---Manage-Address---Landing",
  transform: "translate(-78.000000, -295.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Left-Pane",
  transform: "translate(46.000000, 195.000000)"
}, React.createElement("g", {
  id: "Left-Content",
  transform: "translate(0.000000, 35.000000)"
}, React.createElement("g", {
  id: "Profile",
  transform: "translate(17.000000, 0.000000)"
}, React.createElement("g", {
  id: "Addresses",
  transform: "translate(13.000000, 64.000000)"
}, React.createElement("text", {
  id: "location-pin---simple-line-icons"
}, React.createElement("tspan", {
  x: 0,
  y: 16
}, "\uE096"))))))));

var SvgGpspin = function SvgGpspin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGpspin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gpspin.d860fc12.svg";
export { ForwardRef as ReactComponent };